module.exports = __webpack_public_path__ + "img/ellipse-live.45f6eab0.svg";